// extracted by mini-css-extract-plugin
export default {"recoveryEmailRow":"information_recoveryEmailRow__cS1v7","alterRecoveryEmailBtn":"information_alterRecoveryEmailBtn__aX-nz"};